// =============================================================================
// TESTER ACCESS — EDIT HERE (one place)
// -----------------------------------------------------------------------------
// Friends unlock with: their own email + their own numeric code.
//   • Revoke one person: remove their entry from TESTER_ACCOUNTS.
//   • Change one person's code: edit that person's entry.
//   • Public stays on the Trump demo while CONSTRUCTION_LOCK is true.
// Stripe / paid credits come later — this file is friend testing only.
// =============================================================================

/**
 * CONSTRUCTION LOCK
 * true  = public sees sample (Trump) only; personal charts need tester unlock
 * false = open calculator for everyone (use when Stripe + public launch are ready)
 */
export const CONSTRUCTION_LOCK = true;

/**
 * ADMIN EMAILS — EDIT HERE
 * Admins are EXEMPT from the tester use limit: unlimited chart tests and AI
 * reading generations. They still unlock with their own TESTER_ACCOUNTS entry.
 */
export const ADMIN_EMAILS = ["boblohmeyer@gmail.com"];

/**
 * TESTER USE LIMIT — EDIT HERE
 * Non-admin testers are capped at this many chart tests / AI readings.
 * Admins (ADMIN_EMAILS) are never limited.
 */
export const TESTER_MAX_USES = 10;

/**
 * TESTER ACCOUNTS — ONE EMAIL + ONE CODE PER PERSON
 * Each tester unlocks with their own email and their own numeric code.
 * Email matching is case-insensitive; codes are numbers only.
 * The server mirrors this list in the env var TESTER_ACCOUNTS
 * ("email:code,email:code") — see .env.example.
 *
 * Example:
 *   { email: "friend@example.com", code: "112233" },
 *   { email: "other@example.com",  code: "445566" },
 */
export const TESTER_ACCOUNTS = [
  { email: "boblohmeyer@gmail.com", code: "087491" },
  { email: "magdalena@ginhawaastro.com", code: "985123" },
];

